<h2 mat-dialog-title>Supprimer le Produit</h2>
<div mat-dialog-content>
  <h3>Voulez-vous vraiment supprimer votre produit?</h3>
  <p>
    Vos acheteurs auront toujours accès à leur achat. Le produit ne sera plus
    disponible pour la vente.
  </p>
</div>
<div mat-dialog-actions>
  <button data-test="dismissDeletion" mat-button [mat-dialog-close]="false">
    Ne pas effacer
  </button>
  <button
    data-test="finishOnboarding"
    mat-raised-button
    color="warn"
    [mat-dialog-close]="true"
  >
    Effacer mon produit
  </button>
</div>
